// extracted by css-extract-rspack-plugin
export default {"statusChip":"EDe4rZAi9QFnH4rz","statusBadge":"j_A2HfBHDEUyB7WF","success":"mc55jnNwjBwK5zOr","warning":"iEq8gKa5oEgVj3xX","danger":"uK8MwLDN_ASF1dJh","default":"NQE1HY5SIugmpqh3"};